<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>Type:</label>

        <select name="Type" v-model="encodingData.Type" class="form-control">
          <option value>Select Type</option>
          <option
            v-for="option in types"
            v-bind:value="option.realEstateType"
            v-bind:key="option.realEstateType"
          >{{option.realEstateType}}</option>
        </select>

        <label>RegisterNo :</label>

        <input name="RegisterNo"
        v-validate="'max:50'"
        v-model="encodingData.RegisterNo" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('RegisterNo') }" />
                    <span v-if="submitted && errors.has('RegisterNo')"
                         class="invalid-feedback">
                        {{ errors.first("RegisterNo") }}
                    </span>

        <label>Country:</label>

        <select name="Country" v-model="encodingData.Country" class="form-control">
          <option value>Select Country</option>
          <option
            v-for="option in countries"
            v-bind:value="option.countryName"
            v-bind:key="option.countryName"
          >{{option.countryName}}</option>
        </select>

        <label>State:</label>

        <select name="State" v-model="encodingData.State" class="form-control">
          <option value>Select State</option>
          <option
            v-for="option in provinces"
            v-bind:value="option.province"
            v-bind:key="option.province"
          >{{option.province}}</option>
        </select>

        <label>City :</label>

        <input name="City"
        v-validate="'max:50'" 
        v-model="encodingData.City" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('City') }" />
                    <span v-if="submitted && errors.has('City')"
                         class="invalid-feedback">
                        {{ errors.first("City") }}
                    </span>

        <label>Address :</label>

        <input name="Address"
        v-validate="'max:200'" 
        v-model="encodingData.Address" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Address') }" />
                    <span v-if="submitted && errors.has('Address')"
                         class="invalid-feedback">
                        {{ errors.first("Address") }}
                    </span>

        <label>Location :</label>

        <input name="Location"
        v-validate="'max:50'" 
        v-model="encodingData.Location" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Location') }" />
                    <span v-if="submitted && errors.has('Location')"
                         class="invalid-feedback">
                        {{ errors.first("Location") }}
                    </span>

        <label>PostalCode :</label>

        <input name="PostalCode"
        v-validate="'max:50'"
        v-model="encodingData.PostalCode" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('PostalCode') }" />
                    <span v-if="submitted && errors.has('PostalCode')"
                         class="invalid-feedback">
                        {{ errors.first("PostalCode") }}
                    </span>

        <label>Comments :</label>

        <textarea
          name="Comments"
          v-model="encodingData.Comments"
          class="form-control"
          cols="5"
          rows="5"
        />
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>

import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageRealEstateType
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      encodingData: {
        RealEstateId: '',
        Type: '',
        RegisterNo: '',
        Country: '',
        State: '',
        City: '',
        Address: '',
        Location: '',
        PostalCode: '',
        Comments: ''
      },
      countries: [],
      provinces: [],
      types: []
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created: function() {
    this.getlibs()
  },
  methods: {
    getlibs() {
      
      this.countries = getlocalstorageCountry()
      this.provinces = getlocalstorageProvince()
      this.types = getlocalstorageRealEstateType()
      
      this.getRealEstate()
    },
    handleSubmit() {
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + 'updateRealEstate', this.encodingData, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error) {
            loader.hide()
            notifyHelper('error', response.data.message)
          } else {
            loader.hide()
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-real')
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
    getRealEstate() {
      
      instance
        .get(DataURL + 'realestate?realestateID=' + this.id, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data
              this.encodingData.RealEstateId = data.realEstateId
              this.encodingData.Type = data.type
              this.encodingData.RegisterNo = data.registerNo
              this.encodingData.Country = data.country
              this.encodingData.State = data.state
              this.encodingData.City = data.city
              this.encodingData.Address = data.address
              this.encodingData.Location = data.location
              this.encodingData.PostalCode = data.postalCode
              this.encodingData.Comments = data.comments
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    }
  }
}
</script>
